import { render } from "./IconLoader.vue?vue&type=template&id=f3aa2abc"
import script from "./IconLoader.vue?vue&type=script&lang=js"
export * from "./IconLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Agent/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__